// i18next-extract-mark-ns-start LaRubrique
import React from 'react';
import { useTranslation } from 'react-i18next';
import withNavigation from '../../../hoc/withNavigation';
import { navigate } from '../../../services/navigation';
import { Button } from '../../home/v4/styledComponents';

type RowButtonProps = {
  text: string;
  link: string;
}

function RowButton({ button }: { button: RowButtonProps }) {
  const { t } = useTranslation();
  return (
    <Button dark bigFontSize onClick={() => navigate(button.link)}>
      {t(button.text)}
    </Button>
  );
}

export default withNavigation(RowButton);
